// components/UsageSteps.tsx
"use client";

import { REBOTT_URL_LINE_OA } from "@/config";
import Image from "next/image";
import Link from "next/link";
import { Typography } from "@material-tailwind/react";
import { MotionDiv, MotionSection, MotionForm, Variants } from "@/utils/clientMotion";
// 1) container variants: เปิดใช้ staggerChildren
const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.4, // pop-up ทีละหมื่นวินาที
    },
  },
};

// 2) item variants: Pop-up จากใต้ขึ้น + fade-in
const itemVariants: Variants = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
};

export function UsageSteps() {
  return (
    <MotionSection
      className="pt-20 pb-20 bg-white"
      // กำหนด container variants
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
      variants={containerVariants}
    >
      {/* 1) หัวเรื่อง */}
      <MotionDiv variants={itemVariants} className="text-center mb-7 px-4">
        <Typography {...({} as any)} variant="h2" className="mb-1 text-gray-800">
          ขั้นตอนการใช้งานตู้{" "}
          <span className="text-[#2998E2]">Rebott</span>
        </Typography>
        <Typography {...({} as any)} variant="lead" className="text-[#2998E2]">
          เริ่มคืนขวดง่ายๆ ได้ทันที เพิ่มเพื่อน<br className="block md:hidden" />ด้วย{" "}
          <span className="text-[#4CAF50] font-bold">LINE OA</span> เพื่อดูวิธีการใช้งาน
        </Typography>
      </MotionDiv>

      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 px-4">
        {/* 2) ฝั่งซ้าย */}
        <MotionDiv
          variants={itemVariants}
          className="bg-[#eff6ff] rounded-2xl py-8 px-[1px] flex flex-col items-center text-center"
        >
          <Typography {...({} as any)} as="h3" variant="h4" className="mt-5 text-gray-800">
            กรณีใช้บริการครั้งแรก
          </Typography>
          <Typography {...({} as any)} className="mb-4">
            สแกน{" "}
            <span className="text-[#4CAF50] font-semibold">QR Code</span> เพื่อสมัครสมาชิกและสะสมแต้ม
          </Typography>
          <div className="bg-white p-1 rounded-xl flex justify-center">
            <Link
              href={REBOTT_URL_LINE_OA}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="w-40 h-40 relative cursor-pointer">
                <Image
                  src="/image/lineoa_qrcode_rebott_prd.webp"
                  alt="Rebott LINE OA"
                  fill
                  style={{ objectFit: "contain" }}
                />
              </div>
            </Link>
          </div>
        </MotionDiv>

        {/* 3) ฝั่งขวา */}
        <MotionDiv variants={itemVariants} className="flex justify-center">
        <div className="relative max-w-md w-full aspect-[1344/938]">
          <Image
            src="/image/lineoa_mobile2.webp"
            alt="Rebott LINE OA"
            fill
            className="object-contain"
            priority
          />
          </div>
        </MotionDiv>
      </div>
    </MotionSection>
  );
}

export default UsageSteps;
